// extracted by mini-css-extract-plugin
module.exports = {"table":"table__3IKpA","row":"row__4+zeO","head":"head__y75Tr","nameCell":"nameCell__W6GfL","iconCell":"iconCell__7zUkM","activityCell":"activityCell__w1cdC"};